// Auth0 localstorage/cookies keys
export const CACHE_KEY_PREFIX = '@@auth0spajs@@';
export const CACHE_KEY_USER_SUFFIX = '@@user@@';
export const COOKIES_KEY_PREFIX = 'auth0';
